<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'public-link.edit-corporative-information'">_Editar información corporativa</span>
  </div>
  <!-- Contenedor -->
  @if (corporativeInformationModal.steps.length !== 1) {
    <wizard-steps
      [steps]="corporativeInformationModal.steps"
      [state]="corporativeInformationModal.stepState">
    </wizard-steps>
  }
  @switch (corporativeInformationModal.stepState) {
    @case (1) {
      <div class="configure-customization__container-step">
        @if((!corporativeInformationModal.company.global && !corporativeInformationModal.noGlobal) || (corporativeInformationModal.company.global || (!corporativeInformationModal.company.global && !corporativeInformationModal.noGlobal))){
          <div class="common-status-message__g-container-info">
            <i class="lf-icon-info-full common-status-message__icon-md"></i>
            <div class="common-status-message__g-content">
                <div class="common-status-message__g-icon-text-content">
                  <div class="common-status-message__g-title-subtitle">
                    <span class="common-status-message__g-subtitle"
                      [afTranslate]="!corporativeInformationModal.company.global && !corporativeInformationModal.noGlobal?'corporative-information-modal.identity-specific-info':'corporative-information-modal.identity-global'"></span>
                  </div>
                </div>
                @if (!corporativeInformationModal.company.global && !corporativeInformationModal.noGlobal) {
                  <div class="common-status-message__g-buttons-container">
                    <button class="common-button__link"
                      (click)="glConfig()">
                      <span class="common-button__link-text"
                        [afTranslate]="'corporative-information-modal.restore-global-personalization'">_Restaurar personalización global</span>
                    </button>
                  </div>
                }
            </div>
          </div>
        }
        <div class="configure-customization__form-container">
          <div class="common-container__mandatory-obligatory-message-form">
            <span class="common-tag__mandatory-text-asterisk">*</span>
            <span class="common-tag__mandatory-label-text-obligatory-message"
              [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
          </div>
          <div class="configure-customization__inputs-container">
            <div class="configure-customization__inner-inputs-container">
              <field-type-logo class="field-type-logo__outer-container"
                [field]="corporativeInformationModal.clientLogo"
                [type]="'new'"
                [preSelectItem]="corporativeInformationModal.allLogos"
                [logoInfo]="corporativeInformationModal.company"
                (itemSelected)="itemSelected($event, 'logo')">
              </field-type-logo>
              <field-type-logo
                [field]="corporativeInformationModal.clientFavicon"
                [type]="'favicon'"
                [logoInfo]="corporativeInformationModal.company"
                [preSelectItem]="corporativeInformationModal.company.faviconImg"
                (itemSelected)="itemSelected($event, 'favicon')">
              </field-type-logo>
            </div>
            <div class="configure-customization__inner-inputs-container">
              <field-type-color [field]="corporativeInformationModal.color"
                [preSelectItem]="corporativeInformationModal.company.color"
                (itemSelectedEmit)="itemSelected($event, 'color')">
              </field-type-color>
              <field-type-color [field]="corporativeInformationModal.textColor"
                [preSelectItem]="corporativeInformationModal.company.textColor"
                (itemSelectedEmit)="itemSelected($event, 'textColor')">
              </field-type-color>
              <field-type-list-extended [field]="corporativeInformationModal.footerDesignType"
                [preSelectItem]="corporativeInformationModal.company.footerDesignType"
                [listValues]="corporativeInformationModal.footerDesignTypeList"
                (itemSelected)="itemSelected($event, 'footerDesignType')">
              </field-type-list-extended>
            </div>
          </div>
        </div>
      </div>
    }
    @case (2) {
      <div class="configure-customization__form-container">
        <div class="protection-data-modal__translation-container">
          <div class="common-translations__container">
            <ul class="common-tab__tertiary-list-block">
              @for (selectedLanguage of corporativeInformationModal.corporativeLanguagesSelected; track selectedLanguage.listValueId) {
                <li>
                  <button [ngClass]="{'common-tab__tertiary--selected': selectedLanguage.active && !selectedLanguage.error}"
                    (click)="corporativeChangeActiveLanguagesSelected(selectedLanguage)"
                    class="common-tab__tertiary">
                    <p class="common-tab__tertiary-button-text"
                      [ngClass]="{'common-tab__tertiary-button-text--error': selectedLanguage.error}">
                      @if(corporativeInformationModal.corporativeLanguagesSelected.length > 5){
                        {{selectedLanguage.appLanguage.substring(0, 2).toUpperCase()}}
                        }@else {
                        {{selectedLanguage.text}}
                      }
                    </p>
                    @if (!selectedLanguage.defaultOption) {
                      <button (click)="corporativeRemoveActiveLanguage(selectedLanguage)"
                        class="common-button__icon-xs-noborder">
                        <i class="lf-icon-close-thick common-icon__sm common-icon__neutral">
                        </i>
                      </button>
                    }
                  </button>
                </li>
              }
              @if (corporativeInformationModal.corporativeLanguagesApp.length !== corporativeInformationModal.corporativeLanguagesSelected.length) {
                <li #selectLanguagesContainer>
                  <button (click)="selectLanguagesDropdown.toggle($event, selectLanguagesContainer)"
                    class="common-tab__tertiary"
                    [ngClass]="{'common-tab__tertiary--active': corporativeInformationModal.openLanguagesFooterDropdown}">
                    <p [afTranslate]="'protection-data-modal.add-translation'"
                      class="common-tab__tertiary-button-text">
                      _Añadir traducción
                    </p>
                    <i class="lf-icon-translate common-icon__md"></i>
                  </button>
                  <p-overlayPanel
                    #selectLanguagesDropdown
                    (onShow)="corporativeInformationModal.openLanguagesFooterDropdown = true"
                    (onHide)="corporativeInformationModal.openLanguagesFooterDropdown = false"
                    styleClass="common-dropdown-overlay__container">
                    <ng-template pTemplate="content">
                      <div class="common-dropdown__items-container">
                        @for (language of corporativeInformationModal.corporativeLanguagesApp; track language.listValueId) {
                          @if (corporativeNotSelectLanguage(language)) {
                            <button
                              (click)="corporativeSelectLanguage(language.listValueId, selectLanguagesDropdown)"
                              class="common-dropdown-list__si-button">
                              <span-tooltip
                                class="common-dropdown-list__si-text-container"
                                [text]="language.text"
                                [tooltipPosition]="'top'">
                              </span-tooltip>
                            </button>
                          }
                        }
                      </div>
                    </ng-template>
                  </p-overlayPanel>
                </li>
              }
            </ul>
          </div>
          <field-type-rich-text-editable class="w-[100%]"
            [field]="corporativeInformationModal.corporativeDataTreatment"
            [preSelectItem]="corporativeInformationModal.corporativeDataTreatmentText"
            (itemSelected)="corporativeInformationModal.corporativeDataTreatmentText = $event.newValue">
          </field-type-rich-text-editable>
        </div>
        <div class="configure-customization__fields-container">
          <field-type-text-simple
            [field]="corporativeInformationModal.youtubeLink"
            [preSelectItem]="corporativeInformationModal.company.youtube"
            (itemSelected)="itemSelected($event, 'youtube')">
          </field-type-text-simple>
          <field-type-text-simple
            [field]="corporativeInformationModal.twitterLink"
            [preSelectItem]="corporativeInformationModal.company.twitter"
            (itemSelected)="itemSelected($event, 'twitter')">
          </field-type-text-simple>
        </div>
        <div class="configure-customization__fields-container">
          <field-type-text-simple
            [field]="corporativeInformationModal.facebookLink"
            [preSelectItem]="corporativeInformationModal.company.facebook"
            (itemSelected)="itemSelected($event, 'facebook')">
          </field-type-text-simple>
          <field-type-text-simple
            [field]="corporativeInformationModal.linkedinLink"
            [preSelectItem]="corporativeInformationModal.company.linkedin"
            (itemSelected)="itemSelected($event, 'linkedin')">
          </field-type-text-simple>
        </div>
        <div class="configure-customization__fields-container">
          <field-type-text-simple
            [field]="corporativeInformationModal.instagramLink"
            [preSelectItem]="corporativeInformationModal.company.instagram"
            (itemSelected)="itemSelected($event, 'instagram')">
          </field-type-text-simple>
          <field-type-text-simple
            [field]="corporativeInformationModal.phoneReference"
            [preSelectItem]="corporativeInformationModal.company.phone"
            (itemSelected)="itemSelected($event, 'phone')">
          </field-type-text-simple>
        </div>
        <div class="configure-customization__fields-container">
          <field-type-switch
            [field]="{label: 'corporative-information-modal.show-logo'|afTranslate}"
            [small]="true"
            [preSelectItem]="corporativeInformationModal.company.showLogoInFooter"
            (itemSelected)="itemSelected($event, 'showLogoInFooter')">
          </field-type-switch>
        </div>
      </div>
    }
    @case (3) {
      <div class="common-modal__content-scroll">
        <div class="configure-customization__container-step">
          <p class="common-modal__content-header-info"
            [afTranslate]="'corporative-information-modal.explication-more-info-2'">
            _Si quieres que las notificaciones al usuario del concepto público se remitan desde una cuenta de correo diferente a la del producto, completa los siguientes campos:
          </p>
          <div class="configure-customization__form-container">
            <field-type-switch
              [field]="{label: 'corporative-information-modal.custom-email'|afTranslate}"
              [preSelectItem]="corporativeInformationModal.company.customEmail"
              [small]="true"
              (itemSelected)="itemSelected($event, 'customEmail')">
            </field-type-switch>
            @if (corporativeInformationModal.company.customEmail) {
              <div class="common-container__mandatory-obligatory-message-form">
                <span class="common-tag__mandatory-text-asterisk">*</span>
                <span class="common-tag__mandatory-label-text-obligatory-message"
                  [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
              </div>
              @if (skin==='dark-blue') {
                <field-type-list-extended
                  [field]="corporativeInformationModal.customEmailType"
                  [listValues]="corporativeInformationModal.customEmailTypeOptions"
                  [preSelectItem]="corporativeInformationModal.customTypeSelect"
                  (itemSelected)="selectcustomType($event.newValue)">
                </field-type-list-extended>
              }
              @if(corporativeInformationModal.customTypeSelect ==='0'){
                <div class="configure-customization__fields-container">
                  <field-type-text-simple [field]="corporativeInformationModal.sMTPServerField"
                    [preSelectItem]="corporativeInformationModal.company.smtpServer"
                    (itemSelected)="itemSelected($event, 'smtpServer')">
                  </field-type-text-simple>
                  <field-type-number [field]="corporativeInformationModal.sMTPPortField"
                    [preSelectItem]="corporativeInformationModal.company.smtpPort"
                    (itemSelected)="itemSelected($event, 'smtpPort')">
                  </field-type-number>
                </div>
                <div class="configure-customization__fields-container">
                  <field-type-text-simple [field]="corporativeInformationModal.sMTPUserField"
                    [preSelectItem]="corporativeInformationModal.company.smtpUser"
                    (itemSelected)="itemSelected($event, 'smtpUser')">
                  </field-type-text-simple>
                  <field-type-password [field]="corporativeInformationModal.sMTPPasswordField"
                    [preSelectItem]="corporativeInformationModal.company.smtpPassword"
                    (itemSelected)="itemSelected($event, 'smtpPassword')">
                  </field-type-password>
                </div>
                <div class="configure-customization__fields-container configure-customization__fields-container--center">
                  <field-type-email [field]="corporativeInformationModal.sMTPFromField"
                    [preSelectItem]="corporativeInformationModal.company.smtpFrom"
                    (itemSelected)="itemSelected($event, 'smtpFrom')">
                  </field-type-email>
                  <field-type-switch
                    [field]="{label: 'corporative-information-modal.secure-connection'|afTranslate}"
                    [small]="true"
                    [preSelectItem]="corporativeInformationModal.company.smtpssl"
                    (itemSelected)="itemSelected($event, 'smtpssl')">
                  </field-type-switch>
                </div>
              }@else if(corporativeInformationModal.customTypeSelect ==='1'){
                @if (!corporativeInformationModal.itsConfigurate) {
                  <field-type-email
                    [concept]="corporativeInformationModal.concept"
                    [field]="corporativeInformationModal.authMailField"
                    [preSelectItem]="corporativeInformationModal.mailAuth"
                    (itemSelected)="selectEmail($event.newValue)">
                  </field-type-email>
                }
                <field-type-configurate-oauth
                  [field]="corporativeInformationModal.configureOauth"
                  [oauthUser]="corporativeInformationModal.company.oauthUser"
                  (itemSelected)="itemSelected($event, 'oauthUser')"></field-type-configurate-oauth>
              }
            }
          </div>
        </div>
      </div>
    }
    @case (4) {
      <div class="configure-customization__container-step">
        <p class="common-modal__content-header-info"
        [afTranslate]="'corporative-information-modal.explication-title'">
        _Por defecto, en la cabecera del formulario público se indicará el nombre del concepto. Si lo prefieres, puedes introducir a continuación un título diferente.
        </p>
        <div class="configure-customization__form-container">
          @if (skin !=='icam-red') {
            <div class="common-translations__container">
              <div class="common-tab__tertiary-list-block">
                @for (languageSelected of corporativeInformationModal.languagesSelected; track $index) {
                  <div class="common-tab__tertiary common-tab__tertiary--selected"
                    [ngClass]="{'common-tab__tertiary--selected': languageSelected.active}"
                    (click)="changeActiveLanguagesSelected(languageSelected)">
                    <p class="common-tab__tertiary-button-text"
                      [ngClass]="{'common-tab__tertiary-button-text--error': languageSelected.error}">
                      @if(corporativeInformationModal.languagesSelected.length > 5){
                        {{languageSelected.appLanguage.substring(0, 2).toUpperCase()}}
                      }@else {
                        {{languageSelected.text}}
                      }
                    </p>
                    @if (!languageSelected.defaultOption) {
                      <button class="common-button__icon-xs-noborder"
                        (click)="removeActiveLanguage(languageSelected)">
                        <i class="lf-icon-close-thick common-icon__sm common-icon__neutral"></i>
                      </button>
                    }
                  </div>
                }
                @if (corporativeInformationModal.languagesSelected.length !== corporativeInformationModal.languagesApp?.length) {
                  <div #selectCorporativeLanguagesContainer>
                    <div (click)="corporativeSelectLanguagesDropdown.toggle($event)"
                      class="common-tab__tertiary"
                      [ngClass]="{'common-tab__tertiary--active': corporativeInformationModal.openLanguagesDropdown}">
                      <p class="common-tab__tertiary-button-text"
                        [afTranslate]="'protection-data-modal.add-translation'">
                        _Añadir traducción
                      </p>
                      <i class="lf-icon-translate common-icon__md"></i>
                    </div>
                    <p-overlayPanel
                      #corporativeSelectLanguagesDropdown
                      (onShow)="corporativeInformationModal.openLanguagesDropdown = true"
                      (onHide)="corporativeInformationModal.openLanguagesDropdown = false"
                      styleClass="common-dropdown-overlay__container">
                      <ng-template pTemplate="content">
                        <div class="common-dropdown__items-container">
                          @for (language of corporativeInformationModal.languagesApp; track $index) {
                            @if (notSelectLanguage(language)) {
                              <button
                                (click)="selectLanguageToButton(language.listValueId)"
                                class="common-dropdown-list__si-button">
                                <span-tooltip
                                  class="common-dropdown-list__si-text-container"
                                  [text]="language.text + ' (' + language.specific + ')'"
                                  [tooltipPosition]="'top'">
                                </span-tooltip>
                              </button>
                            }
                          }
                        </div>
                      </ng-template>
                    </p-overlayPanel>
                  </div>
                }
              </div>
            </div>
          }
          <field-type-text-simple [field]="corporativeInformationModal.dataTreatment"
            [preSelectItem]="corporativeInformationModal.dataTreatment.preSelectItem"
            (itemSelected)="changeField($event.newValue)">
          </field-type-text-simple>
        </div>
      </div>
    }
  }
  <!-- Footer botonera -->
  <div class="common-modal__footer-container">
    <button class="common-button__text-noborder"
      [disabled]="corporativeInformationModal.notifyDisabled"
      (click)="showPreview()">
      <i class="lf-icon-visible common-icon__md"></i>
      <span class="common-button__text-title"
        [afTranslate]="'corporative-information-modal.notify-model'">_Ver modelo de notificación</span>
    </button>
    <div class="common-modal__footer">
      <button [ngClass]="corporativeInformationModal.stepState === 1?'common-button__text-border':'common-button__text-noborder'"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      @if (corporativeInformationModal.stepState > 1) {
        <button class="common-button__text-border"
          (click)="prevStep()">
          <span class="common-button__text-title"
            [afTranslate]="'common.previous'">_Anterior</span>
        </button>
      }
      @if(corporativeInformationModal.stepState === 4){
        <button class="common-button__text"
          (click)="saveCorporativeInformation()">
          <span class="common-button__text-title"
            [afTranslate]="'common.save'">_Guardar</span>
        </button>
      }@else {
        <button class="common-button__text"
          (click)="nextStep()">
          <span class="common-button__text-title"
            [afTranslate]="'common.next'">_Siguiente</span>
        </button>
      }
    </div>
  </div>
</div>
